/* eslint-disable react/jsx-pascal-case */
import React from "react";
import {connect} from "react-redux";
import Messages_Room_Window from "./Messages_Room_Window.js";
import Messages_Room_Window_Default from "./Messages_Room_Window_Default";

class Messages_Right extends React.Component {
    shouldComponentUpdate(prevProps,prevState) {
        if (prevProps.second_user !== this.props.second_user) {
            return true;
        }
    }
    render() {
        return (this.props.second_user.length !== 0) ?
        <div className="messages_room_window">
            <Messages_Room_Window />
        </div> :
        <div className="messages_room_window">
            <Messages_Room_Window_Default />
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        second_user: state.getSecondUser.second_user
    }
}
export default connect(mapStateToProps)(Messages_Right);